import { Request } from '~src/httpClient/serverApi/requests/Request';

export interface IGetDependentDataSourcesParams {
  dataSourceId: string;
}

export interface IGetDependentDataSourcesResult {
  dependentDataSourceIds?: string[];
}

export class GetDependentDataSourcesRequest extends Request<IGetDependentDataSourcesParams, IGetDependentDataSourcesResult> {
  constructor(params: IGetDependentDataSourcesParams) {
    super('getDependentDataSources', params);
  }
}
